
import { useEffect } from 'react';
import OneSms from './OneSms'


function SmsList({info  ,handleEdit}){

    const hasScrollbar = () => {
        const tablebody = document.querySelector('tbody');
        if(info.length*35 <= tablebody.clientHeight) tablebody.style.width = '100%'
        else tablebody.style.width = 'calc(100% + 10px)'
    }

    useEffect(() => {
        hasScrollbar();
        window.addEventListener('resize', hasScrollbar);
        return () => {
            window.removeEventListener('resize', hasScrollbar);
        }
    }, [info])

    return (
        <tbody>
            {info.length === 0 ? 
                <tr>
                    <td colSpan='8'>SMS 수신 내역이 존재하지 않습니다.</td>
                </tr>
            :
                info.map( sms =>{
                    return(
                       <OneSms key={sms.sms_idx} item={sms}  handleEdit={handleEdit} />
                    );
                })
            }
        </tbody>
    );

}

export default SmsList;